import styled from 'styled-components';
import Fab from '@material-ui/core/Fab';

export const StyledFab = styled(Fab)`
    && {
        transform: scale(0.7);
    }
`